import { ModuloForm, RolModulo, RolModuloForm, RolModuloUpsert } from '@models/.';
import { transformArrayRoleModulePermissionForm, transformArrayRoleModulePermissionUpsert } from '..';
import { RolModuleEnum } from '@core/enums';

export function transformToData(rolModule: RolModulo | null): RolModulo | null {
  if (!rolModule) return null;
  
  return {
    ...rolModule,
  };
}

export function transformToForm(rolModule?: RolModulo): RolModuloForm | undefined {
  if (!rolModule) return;
  
  const {
    idModule: id,
    name: name,
    code: code,
    enabled: enabled,
    permissions: permissions,
  } = rolModule;
  
  return {
    id,
    name,
    code,
    enabled,
    permissions: transformArrayRoleModulePermissionForm(permissions),
  };
}

export function transformArrayToForm(rolModules: RolModulo[] | null | undefined): RolModuloForm[] {
  return (rolModules ?? []).map((rolModule) => (transformToForm(rolModule)) as RolModuloForm) ?? [];
}

export function transformArrayFormToOrder(rolModulesForm: RolModuloForm[]): RolModuloForm[] {
  const customOrder = [
    RolModuleEnum.Role,
    RolModuleEnum.User,
    RolModuleEnum.Store,
    RolModuleEnum.Account,
  ];
  
  return (rolModulesForm ?? []).sort((a, b) => {
    const indexA = customOrder.indexOf(a.code as RolModuleEnum);
    const indexB = customOrder.indexOf(b.code as RolModuleEnum);
      
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    return 0;
  });
}

export function transformToUpsert(rolModuleForm: RolModuloForm): RolModuloUpsert | undefined {
  if (!rolModuleForm) return;
  
  const {
    id,
    enabled,
    permissions,
  } = rolModuleForm
  
  return {
    idModule: id,
    enabled,
    permissions: transformArrayRoleModulePermissionUpsert(permissions),
  };
}

export function transformArrayToUpsert(rolModulesForm: RolModuloForm[] | null | undefined): RolModuloUpsert[] {
  return (rolModulesForm ?? []).map((rolModuleForm) => (transformToUpsert(rolModuleForm)) as RolModuloUpsert) ?? [];
}

export function transformToModuleForm(rolModule?: RolModulo): ModuloForm | undefined {
  if (!rolModule) return;
  
  const {
    idModule: id,
    name: name,
    code: code,
    enabled: enabled,
    permissions: permissions,
  } = rolModule;
  
  return {
    id,
    name,
    code,
    enabled,
    permissions: transformArrayRoleModulePermissionForm(permissions),
  };
}

export function transformArrayToModuleForm(rolModules: RolModulo[] | null | undefined): ModuloForm[] {
  return (rolModules ?? []).map((rolModule) => (transformToModuleForm(rolModule)) as ModuloForm) ?? [];
}